'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toggle = function (_Component) {
	_inherits(Toggle, _Component);

	function Toggle(props) {
		_classCallCheck(this, Toggle);

		return _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props));
	}

	_createClass(Toggle, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    wrapperClass = _props.wrapperClass,
			    label = _props.label,
			    onChange = _props.onChange,
			    twoSided = _props.twoSided,
			    rest = _objectWithoutProperties(_props, ['wrapperClass', 'label', 'onChange', 'twoSided']);

			var id = _underscore2.default.uniqueId('toggle_');
			var checked = this.props.active || false;
			return _react2.default.createElement(
				'div',
				{ className: "input-wrapper toggle-wrapper " + wrapperClass },
				_react2.default.createElement('input', {
					type: 'checkbox',
					onChange: onChange,
					checked: checked,
					id: id
				}),
				_react2.default.createElement('div', { className: (0, _classnames2.default)("toggle", { active: checked, twoSided: twoSided }), onClick: this.handleClick.bind(this) }),
				label && _react2.default.createElement(
					'label',
					{ htmlFor: id },
					label
				)
			);
		}
	}, {
		key: 'handleClick',
		value: function handleClick() {

			var checked = this.props.active || false;

			var e = {
				target: {
					type: 'checkbox',
					checked: !checked
				}
			};

			this.props.onChange(e);
		}
	}]);

	return Toggle;
}(_react.Component);

exports.default = Toggle;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/form/Toggle.js
// module id = 570
// module chunks = 0